// @flow
import React, { Component } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import HintWrapper from '../controls/HintWrapper'
import type { Options, OptionType } from '../types'
import Switcher from '../controls/Switcher'
import _ from 'lodash'

type Props = {|
  options: Options,
  onChange?: Function,
  hideHints?: boolean,
  value: string
|}

const t = translateFunc(translations.payment_type_select)

export default class PaymentTypeSelect extends Component<Props> {
  t: Function

  render() {
    return (
      <Switcher
        value={this.props.value}
        options={_.map(this.props.options, ([name, id]) => ({ id, name }))}
        labelRenderer={(option) => this.renderLabel(option)}
        onChange={(value) => this.valueChanged(value)}
      />
    )
  }

  renderLabel(option: OptionType) {
    return !this.props.hideHints && this.optionValue(option) === 'auto' ? (
      <HintWrapper
        triggerText={this.optionLabel(option)}
        popupText={t('auto_description')}
        alignLeft
      />
    ) : (
      this.optionLabel(option)
    )
  }

  optionValue(option: OptionType): string {
    return option.id
  }

  optionLabel(option: OptionType): string {
    return option.name
  }

  valueChanged(value: string) {
    this.props.onChange && this.props.onChange(value)
  }
}
